import React, { useMemo } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { ButtonSizeEnum, ButtonVariantEnum, Group, Link, Stack, Text } from '@affstore-ds/uikit'

import { getBrandConfig } from '../../config/brands'
import { LanguageDropdown } from '../../features/LanguageDropdown'
import { guestFooterTranslationKeys } from './translations/GuestFooter.translationKeys'

const { brandConfig } = getBrandConfig()

export const GuestFooter = () => {
  const { i18n } = useI18n()

  const currentYear = useMemo(() => new Date().getFullYear(), [])

  const copyRightsText = useMemo(() => `${brandConfig.copyRights}-${currentYear}`, [currentYear])

  return (
    <Stack align="center" gap={12} mt={20}>
      <LanguageDropdown type="guest" />
      <Group align="center" gap={16} justify="center" wrap="wrap">
        <Link
          data-testid="link-agreement"
          elementSize={ButtonSizeEnum.S}
          elementVariant={ButtonVariantEnum.SecondaryMainLine}
          href={brandConfig.termsAndConditionUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {i18n.t(guestFooterTranslationKeys.agreement)}
        </Link>
        <Link
          data-testid="link-privacy-notice"
          elementSize={ButtonSizeEnum.S}
          elementVariant={ButtonVariantEnum.SecondaryMainLine}
          href={brandConfig.privacyPolicyUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {i18n.t(guestFooterTranslationKeys.privacyNotice)}
        </Link>
      </Group>
      <Group align="baseline" gap={12}>
        <Link
          data-testid="link-mailto-support"
          elementSize={ButtonSizeEnum.S}
          elementVariant={ButtonVariantEnum.SecondaryMainLine}
          href={`mailto:${brandConfig.supportEmail}`}
        >
          {brandConfig.supportEmail}
        </Link>
        <Text colorVariant="greyIron.13" component="span" elementSize="xs" elementVariant="important">
          &copy; {copyRightsText}
        </Text>
      </Group>
    </Stack>
  )
}
